import { Tooltip as AntdTooltip } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { colors } from '../../styles/colors/';

const Styled = styled.div`
  .ant-tooltip-inner {
    background-color: ${(props) => props.color};
    font-size: ${(props) => (props.isMobile ? '16px' : '14px')};
    color: ${(props) => colors['gray']['1']};
    line-height: ${(props) => (props.isMobile ? '24px' : '22px')};
  }

  .ant-tooltip-arrow {
    border-bottom-color: ${(props) => props.isTopBottom && props.color};
    border-top-color: ${(props) => props.isTopBottom && props.color};
    border-left-color: ${(props) => !props.isTopBottom && props.color};
    border-right-color: ${(props) => !props.isTopBottom && props.color};
  }
`;

/**
 * Primary UI component for user interaction
 */
const Tooltip = ({
  title,
  color = colors['indigo']['7'],
  placement = 'bottomRight',
  overlayInnerStyle,
  isMobile,
  children,
  ...props
}) => {
  const placementSetting = isMobile ? 'bottomRight' : placement;
  const isTopBottom = [
    'top',
    'bottom',
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
  ].includes(placement);

  return (
    <Styled color={color} isTopBottom={isTopBottom}>
      <AntdTooltip
        title={title}
        placement={placementSetting}
        getPopupContainer={(triggerNode) => triggerNode}
        {...props}
      >
        {children}
      </AntdTooltip>
    </Styled>
  );
};

Tooltip.propTypes = {
  title: PropTypes.string,

  color: PropTypes.string,

  placement: PropTypes.oneOf([
    'top',
    'left',
    'right',
    'bottom',
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom',
  ]),

  overlayInnerStyle: PropTypes.object,

  isMobile: PropTypes.bool,
};

Tooltip.defaultProps = {
  isMobile: false,
};

export { Tooltip };
